
import React from 'react'
import { Helmet } from 'react-helmet';
import { useMediaQuery } from 'react-responsive'
import { useNavigate, Link } from "react-router-dom"
import Button from '../../components/Button'
import Return from '../../components/Forum/Return'
import CommentIcon from '../../images/comment.svg'
import LikeIcon from '../../images/like.svg'

export default function Post82() {

  const tabletBreakpoint = useMediaQuery({ query: '(min-width: 768px)' })

  const navigate = useNavigate()

  React.useEffect(() => { 
    window.scrollTo(0, 0)
  }, [])


  return (

    <div className="top-margin-s">

      <Helmet>
        <title>Oi pessoal, bom dia! Alguém aqui já viu nos exames o termo opacidade nodular? Pode me ajudar com oque significa.</title>
        <meta 
          name="description" 
          content="Oi pessoal, bom dia! Alguém aqui já viu nos exames o termo opacidade nodular? Pode me ajudar com oque significa."/>
      </Helmet>

      <div className={(tabletBreakpoint) ? 
        "container-simple-tablet" : "container-simple"}>
        <div className="top-margin-s bottom-margin-s">
          <Return to='/forum' />
        </div>
        <div className="bottom-margin-s">
          <p className="secondary-text bottom-margin-xs">
            Mariano Oliveira &#183; 13/08/2024
          </p>
        </div>


        <p className="body content bottom-padding-s">
            Oi pessoal, bom dia! Alguém aqui já viu nos exames o termo opacidade nodular? Pode me ajudar com oque significa.
        </p>


        <div className="post-stats bottom-padding-xs">
          <button onClick={()=>{navigate('/forum/82')}} className="svg-btn">
            <div className="post-useful-info">
              <div> 
               <img src={LikeIcon} alt="Button indicating if you found this useful" />
              </div>
              <p className="secondary-text">
                  3 pessoas acharam útil
              </p>
            </div>
          </button>

          <div className="post-useful-info"> 
            <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
            <p className="secondary-text">
              1 comentário
            </p>
          </div> 
        </div>
        <div className="top-padding-xs">

              <div className="comment-background comment">
                <p className="body comment-fixed">
                  Oi Mariano, bom dia!<br/><br/>Entendo como pode ser preocupante ver termos desconhecidos nos exames. "Opacidade nodular" geralmente significa uma área onde o tecido pulmonar parece mais denso ou espesso em um exame de imagem, como um raio-X ou tomografia. Isso pode ser causado por várias coisas, desde infecções até condições mais sérias como câncer.<br/><br/>É muito importante que você discuta isso com seu médico, pois ele(a) é a melhor pessoa para interpretar seus resultados específicos e explicar o que está acontecendo no seu caso.<br/><br/>Tente não se preocupar antes de falar com seu médico. Eles terão a melhor informação e poderão te orientar sobre os próximos passos. Se precisar de mais alguma coisa, estamos aqui para ajudar.<br/><br/>Abraços,<br/>Florence
                </p>
              </div>

              <div className="post-stats">
                <div className="bottom-margin-s">
                  <p className="secondary-text bottom-margin-xs">
                    Florence Health &#183; 13/08/2024
                  </p>
                </div>
              </div>


          <Button type="primary bottom-margin-s" onClick={()=>{navigate('/forum/82')}}>Comentar</Button>
        </div>

        <div className="top-padding-s">
          <p className="heading4 bottom-padding-xs bottom-border">Postagens Relacionadas</p>


              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Leonardo Silveira &#183; 18/07/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/2-geral" reloadDocument={true}>

                  <p className="heading4 primary-color bottom-margin-xs">
                    Os benefícios para saúde de ter um Border Collie  
                  </p>

                  <p className="body primary-color content bottom-padding-xs">
                    Há anos atrás, quando estava na faculdade, eu costumava correr na rua em algum parque 2 ou 3 vezes na semana, por cerca de 30 minutos. Com o tempo, e conforme fui ficando mais ocupado, acabei deixando esse bom hábito de lado. E uma vez que o hábito de exercício físico normalmente traz consigo outros hábitos, como de uma alimentação mais saudável e menos bebida alcoólica, esses também foram se deteriorando com o tempo. Consequentemente, ao longo dos anos sutilmente resultados disso foram surgindo, como aumento de peso e menor disposição.<br/><br/>Dois anos atrás, porém, decidi junto com minha esposa adotar um cachorro, e escolhemos uma Border Collie. A nova integrante da família, conforme nós esperávamos, nos forçou a uma série de mudanças na rotina. Eu fiquei responsável pelos passeios duas vezes por dia: às 6 da manhã, antes do trabalho, e no final da tarde. Isso me forçou diretamente e sem rodeios a iniciar uma atividade física disfarçada, que foram as caminhadas com nossa cachorra, que foram aumentando de duração e intensidade conforme ele crescia.<br/><br/>A raça Border Collie é conhecida por ser a raça mais inteligente, e também de alta energia. E sem dúvida existe alguma verdade nessa afirmação. As caminhadas deixaram de ser o bastante para a nossa cachorra, e para conseguir gastar sua energia e mantê-la saudável treinamos ela para jogar frisbee: pegar o disco no ar após jogarmos e traze-lo novamente para nós, em um ciclo aparentemente infinito de arremessos. Ela aprendeu rapidamente o esporte e se tornou um dos melhores cachorros que já vimos pegando o disco no ar em saltos acrobáticas.<br/> <br/>Porém, as caminhadas intensas duas vezes por dia com ela me fez lembrar de como eu me sentia bem após uma corrida intensa na época da faculdade, e como estava disposto no dia seguinte para o estudo e trabalho. Com isso, comecei aos poucos a correr junto de minha cachorra na rua. Essa corrida foi aumentando, primeiro somente a tarde alguns dias, depois mais alguns dias de manhã, e por fim, hoje corro com ela todos os dias de manhã e a tarde.<br/><br/>Isso mantém minha cachorra feliz e nós dois saudáveis, além de me manter disposto e com mais energia do que me sentia em anos. E hoje nem penso em não fazer isso, simplesmente porque sei como me sinto e vejo como ela fica feliz na horário dos nossos passeios. Esse são alguns, dos muitos benefícios de ter um Border Collie (ou qualquer outro cachorro) como companheiro.<br/>
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/2')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            2 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Rita Anton &#183; 12/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/79-pressao" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Oi pessoal, sou hipertensa e hoje minha pressão diastólica não saiu do 10 ou 9 ....<br/>A sistólica fica entre 12 e 13 e a diastólica entre 9 e 10.<br/>Oque vocês acham que eu devo fazer?<br/>Já tomei o remédio da pressão as 18 horas tomo a cada 12 horas, mas tenho ansiedade e não estou nem conseguindo dormir porque a pressão não abaixa.<br/>Já tá me dando até dor de cabeça
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/79')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            4 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Tami Costa &#183; 06/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/25-diabetes" reloadDocument={true}>

                  <p className="heading4 primary-color bottom-margin-xs">
                    Dúvida hipoglicemia:  
                  </p>

                  <p className="body primary-color content bottom-padding-xs">
                    Quanto de glicemia é considerado hipoglicemia? Hoje estava com 75, mas não estava sentindo nada
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/25')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            2 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Joana Ling &#183; 10/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/56-diabetes" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Quem tem diabetes pode comer cenoura?
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/56')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            1 pessoa achou útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Vitor Machado &#183; 21/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/140-diabetes" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Alguém aqui toma rybelsus para controle da glicemia?<br/>Eu sinto muito enjoo e não tenho apetite, mas mesmo assim a glicose continua alta
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/140')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            4 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>


        </div>

      </div>
    </div>
  )
}
